export class HolidayModel {
    id: number = 0;
    schoolYearId: number = 0;
    holidayTypeId: number = 0;
    startDate: string = '';
    endDate: string = '';
    holidayTypeName: string = '';
    schoolYearName: string = '';
} 